import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import LoanAgreementEscrowTermsPageUI from './LoanAgreementEscrowTermsPageUI.js'

class LoanAgreementEscrowTermsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      template: null
    }
  }

  render() {
    return (
      <LoanAgreementEscrowTermsPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        escrowSp={this.getEscrowCode()}
        template={this.state.template}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan }, () => {
      if (!response.errorList || response.errorList.length === 0) {
        this.getTemplates(context)
      }
    })
  }

  getTemplates(context) {
    let escrowSp = this.getEscrowCode()
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/templates/${escrowSp}`,
      cacheKey: CacheKeys.Templates(this.props.match.params.loanId, 'escrowSp'),
      callback: this.getTemplatesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getTemplatesCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      template: response.template,
    })
  }

  getEscrowCode() {
    let loan = this.state.loan
    let escrow = loan && loan.escrow
    let specialTerms = loan && loan.specialTerms

    if (escrow !== 'na' && specialTerms) {
      return 'loan_agreement_escrow_sp'
    }
    if (escrow !== 'na' && !specialTerms) {
      return 'loan_agreement_escrow'
    }
    if (escrow === 'na' && specialTerms) {
      return 'loan_agreement_sp'
    }
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
    CacheManager.removeObject(CacheKeys.Templates(this.props.match.params.loanId, 'escrowSp'))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
    }
    else {
      this.setState({
        template: null,
        errorList: null,
      })
      this.getLoan(context)
      this.getTemplates(context)
    }
  }
}

export default withRouter(LoanAgreementEscrowTermsPageSF)
